import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { VoaSummaryFilter, VoaSummaryTable } from "../components";
import * as voa_summary from "../redux";

export class VoaSummaryList extends Component {
    componentDidMount() {
        this.props.getVoaSummary();
    }

    render() {
        const { voa_summaries, pagination, changePage, loading, extraProps } = this.props;
        const base_op = {
            className: "voa_summary_list",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "VOA Summary" }],
            extraProps,
            loading
        };

        const voaTable_op = {
            list: voa_summaries,
            pagination: {
                ...pagination,
                changePage
            }
        };
        return (
            <Base {...base_op}>
                <VoaSummaryFilter onSubmit={this.onFilter} />
                <VoaSummaryTable {...voaTable_op} />
            </Base>
        );
    }

    onFilter = filters => {
        this.props.changeFilters(filters);
    };
}

const mapStateToProps = store => ({
    voa_summaries: store.voa_summary.list,
    loading: store.voa_summary.loading,
    loaded: store.voa_summary.loaded,
    pagination: store.voa_summary.pagination
});

const mapDispatchToProps = dispatch => ({
    getVoaSummary: () => dispatch(voa_summary.actions.getVoaSummary()),
    changePage: page => dispatch(voa_summary.actions.changePage(page)),
    changeFilters: filters => dispatch(voa_summary.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(VoaSummaryList);
